module.exports = __webpack_public_path__ + "img/rating-3.d6267ab0.svg";